import useMonolithApiQuery, { UseMonolithApiQueryOptions } from '@/hooks/api/useMonolithApiQuery';
import { SimpleErrorResponse } from '@/models/Error';
import { HtmlReport } from '@/models/HtmlReport';
import { getPipelineHtmlReportsPath } from '@/utils/monolithApiRouteService';

export type UsePipelineHtmlReportsProps = {
  appSlug: string;
  attemptId: string;
  pipelineSlug: string;
  excludeCategory?: string;
  options?: UseMonolithApiQueryOptions<HtmlReport[], SimpleErrorResponse>;
};

const usePipelineHtmlReports = ({
  appSlug,
  attemptId,
  excludeCategory,
  options,
  pipelineSlug,
}: UsePipelineHtmlReportsProps) => {
  const url = getPipelineHtmlReportsPath(appSlug, pipelineSlug, attemptId);
  const params = { ...options?.requestConfig?.params, exclude_category: excludeCategory };

  return useMonolithApiQuery<HtmlReport[], SimpleErrorResponse>([url, params], url, {
    ...options,
    requestConfig: {
      ...options?.requestConfig,
      params,
    },
  });
};

export default usePipelineHtmlReports;
